import * as apps from '../../../enums/apps';

export const formatUnreadCount = (count) => {
    if (!count || !Number.isInteger(count)) {
        return null;
    }

    if (count > 99) {
        return '99+';
    }

    return `${count}`;
};

export const source = (item) =>
    item.type === apps.APP_NAME_NOTIFICATIONS ? apps.APP_NAME_NOTIFICATIONS : apps.APP_NAME_INBOX;
